import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "menu-heading" }, "workspaces", -1)
const _hoisted_2 = {
  key: 0,
  class: "menu-item py-8"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  class: "heading-1 flex items-center justify-center rounded-base",
  style: { 'min-width': '40px', width: '40px', height: '40px' }
}
const _hoisted_5 = {
  class: "page overflow-hidden overflow-ellipsis",
  style: { 'line-height': '100%' }
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" new workspace ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "",
    ref: "content",
    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
    tabindex: "0"
  }, [
    _hoisted_1,
    (_ctx.workspaces.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Icon, {
            icon: ['fal', 'spinner-third'],
            spin: "",
            style: { width: '40px', height: '40px' }
          })
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspaces, (workspace) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["menu-item px-sidebar py-8 gap-5 cursor-pointer hover:bg-warm", { 'bg-warm': workspace.id == _ctx.currentWorkspace }]),
        onClick: ($event: any) => (_ctx.openWorkspace(workspace.id)),
        tabindex: "0",
        key: workspace.id
      }, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(workspace.icon), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(workspace.name), 1)
      ], 10, _hoisted_3))
    }), 128)),
    _createElementVNode("div", {
      class: "menu-item hover:bg-warm cursor-pointer border-t border-charcoal-ghost",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createWorkspace && _ctx.createWorkspace(...args))),
      tabindex: "0"
    }, [
      _createVNode(_component_Icon, {
        icon: ['fal', 'plus-square'],
        class: "icon-sm"
      }),
      _hoisted_6
    ])
  ], 544))
}